import weatherIcon from './img/weatherIcons.png';
import {imgLoaded, preloaderDisplay} from './actions';
import store from './index';

export default function preloadImage() {
    return (dispatch) => {
        let img = new Image();
        img.src = weatherIcon;
        img.addEventListener('load', () => {
            dispatch(imgLoaded(true, img.width, img.height));
            if (store.getState().currentWeatherData
                && store.getState().forecastWeatherData) {
                dispatch(preloaderDisplay(false));
            }
        });
    }
}